
export default class Asset
{
    constructor() {
      this.name = ''
      this.configs = []
      this.config_id = ''
      this.moderated = false
    }
}